import { logWrapper } from '../utils';
import jQuery from 'jquery';

function ddvHideColumnDirectiveFactory(runtimeConstant) {
  function isOverflow(viewport, column, scrollSelector) {
    const viewportWidth = jQuery(viewport).width();
    const viewportHeight = jQuery(viewport).height();
    const documentScrollTop = jQuery(scrollSelector).scrollTop();
    const documentScrollLeft = jQuery(scrollSelector).scrollLeft();

    const $column = jQuery(column);

    if (viewportWidth === 0) return true;

    const elementOffset = $column.offset();
    const elementHeight = $column.height();
    const elementWidth = $column.width();

    const minTop = documentScrollTop;
    const maxTop = documentScrollTop + viewportHeight;
    const minLeft = documentScrollLeft;
    const maxLeft = documentScrollLeft + viewportWidth - 20;

    const fitsVertically =
      elementOffset.top > minTop && elementOffset.top + elementHeight < maxTop;
    const fitsHorizontally =
      elementOffset.left > minLeft && elementOffset.left + elementWidth < maxLeft;

    return !(fitsVertically && fitsHorizontally);
  }

  function hideOverflowColumns(element, columns, scrollSelector) {
    const $scope = element.scope();

    for (let i = 0; i < columns.length; i++) {
      const colElement = columns[i];
      const column = $scope.columns[i];

      if (isOverflow(element, colElement, scrollSelector)) {
        column.visible = false;
      }
    }
  }

  function link(scope, element) {
    scope.$watch(
      () => element.height(),
      (newValue, oldValue) => {
        if (element.height() === 0 || element.width() === 0) return;

        if (newValue !== oldValue) {
          const $scope = element.scope();
          const columns = element.find('th');

          let actualSize = 0;
          let initialSize = 0;

          hideOverflowColumns(element, columns, scope.scrolled);

          if (actualSize - initialSize > 0) {
            let space = actualSize - initialSize;

            const hiddenColumns = (col) => col.visible === false && parseInt(col.width, 10) <= space;

            while (space > 0) {
              const hidden = $scope.columns.find(hiddenColumns);

              if (hidden !== undefined) {
                space -= parseInt(hidden.width, 10);
                hidden.visible = true;
              } else {
                space = 0;
              }
            }
          }
        }
      }
    );
  }

  function run() {
    return {
      restrict: 'A',
      scope: {
        scrolled: '@ddvHideColumn',
      },
      link,
    };
  }

  return logWrapper(run, runtimeConstant.isDebugDirectives)();
}

export const ddvHideColumnDirective = ['runtimeConstant', ddvHideColumnDirectiveFactory];
